import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function WhatsAppFloat() {
  const { config } = useStore();
  const number = (config.whatsapp_number || "").replace(/\D/g, "");
  const label = "Talk to a Gifting Expert";

  const inner = (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="flex items-center gap-3 bg-[#121212] border border-champagne/40 text-ivory pl-4 pr-5 py-3 shadow-2xl shadow-black/40 hover:bg-champagne hover:text-charcoal hover:border-champagne transition-colors duration-300 group"
    >
      <MessageCircle size={18} strokeWidth={1.5} className="text-champagne group-hover:text-charcoal transition-colors" />
      <span className="text-[11px] font-mono uppercase tracking-[0.18em]">{label}</span>
    </motion.div>
  );

  return (
    <div className="fixed bottom-5 right-5 z-40" data-testid="whatsapp-float">
      {number ? (
        <a
          data-testid="whatsapp-float-link"
          href={`https://wa.me/${number}?text=${encodeURIComponent("Hello THE GOOD GRID, I'd like to discuss a corporate gifting requirement.")}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
        >
          {inner}
        </a>
      ) : (
        <Link data-testid="whatsapp-float-link" to="/request-quote" aria-label={label}>
          {inner}
        </Link>
      )}
    </div>
  );
}
